import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { MenuIcon, XIcon } from "lucide-react";
interface NavbarProps {
  onBook: () => void;
}
const links = [{
  label: "Beranda",
  href: "#home"
}, {
  label: "Aktivitas",
  href: "#activities"
}, {
  label: "Menu",
  href: "#menu"
}, {
  label: "Lokasi",
  href: "#locations"
}, {
  label: "Tentang",
  href: "#about"
}];
export function Navbar({
  onBook
}: NavbarProps) {
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const onResize = () => {
      if (window.innerWidth >= 1024) setOpen(false);
    };
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);
  return <header className="fixed inset-x-0 top-0 z-40 border-b border-espresso-line bg-espresso" data-id="element-217" data-mp="9j00nm46pxpe">
      <nav className="mx-auto flex h-16 max-w-7xl items-center justify-between px-5 sm:px-8" aria-label="Navigasi utama" data-id="element-218" data-mp="1pwq5iv34oq03">
        <a href="#home" className="flex items-center gap-2.5 text-cream" data-id="element-219" data-mp="9opvl9cr6h0l">
          <span className="flex h-8 w-8 items-center justify-center rounded-full bg-sage text-sm font-bold" data-id="element-220" data-mp="9qtypp2tvbzt">
            5
          </span>
          <span className="whitespace-nowrap text-[17px] font-semibold tracking-tight" data-id="element-221" data-mp="jmdvedp7uepm">
            Kopi Lima Detik
          </span>
        </a>

        <ul className="hidden items-center gap-8 lg:flex" data-id="element-222" data-mp="ojnrudb0vqmy">
          {links.map(link => <li key={link.href} data-id="element-223" data-mp="3n573iaz86bce">
              <a href={link.href} className="text-sm font-medium text-cream/75 transition-colors duration-150 hover:text-cream" data-id="element-224" data-mp="3s27aco3wfi4k">
                {link.label}
              </a>
            </li>)}
        </ul>

        <div className="flex items-center gap-2" data-id="element-225" data-mp="5o74ximljgzz">
          <button type="button" onClick={onBook} className="hidden whitespace-nowrap rounded-full bg-sage px-5 py-2.5 text-sm font-semibold text-cream transition-[background-color,transform] duration-150 ease-out hover:bg-sage-dark active:scale-[0.97] sm:inline-flex" data-id="element-226" data-mp="34de8kb0lig21">
            Pesan Aktivitas / Order
          </button>
          <button type="button" onClick={() => setOpen(v => !v)} className="flex h-10 w-10 items-center justify-center rounded-full text-cream transition-colors duration-150 hover:bg-espresso-light lg:hidden" aria-expanded={open} aria-controls="mobile-menu" aria-label={open ? "Tutup menu" : "Buka menu"} data-id="element-227" data-mp="3b134vf6m9b56">
            {open ? <XIcon className="h-5 w-5" data-id="element-228" data-mp="2salehh99armz" /> : <MenuIcon className="h-5 w-5" data-id="element-229" data-mp="2sav59724l2tq" />}
          </button>
        </div>
      </nav>

      <AnimatePresence data-id="element-230" data-mp="2naz37dcznlgt">
        {open && <motion.div id="mobile-menu" initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -8
      }} transition={{
        duration: 0.2,
        ease: [0.23, 1, 0.32, 1]
      }} className="border-t border-espresso-line bg-espresso px-5 pb-6 pt-2 lg:hidden" data-id="element-231" data-mp="2na759vvx5bnd">
            <ul className="flex flex-col" data-id="element-232" data-mp="f4eqtxrya5dy">
              {links.map(link => <li key={link.href} data-id="element-233" data-mp="14414y2dmwud">
                  <a href={link.href} onClick={() => setOpen(false)} className="block border-b border-espresso-line py-3.5 text-base font-medium text-cream/85" data-id="element-234" data-mp="155lxu972xpa">
                    {link.label}
                  </a>
                </li>)}
            </ul>
            <button type="button" onClick={() => {
          setOpen(false);
          onBook();
        }} className="mt-5 w-full rounded-full bg-sage py-3 text-sm font-semibold text-cream" data-id="element-235" data-mp="xw7i9nrdfijk">
              Pesan Aktivitas / Order
            </button>
          </motion.div>}
      </AnimatePresence>
    </header>;
}